/**
 * Stake Program constants and configuration
 */

import { LEGACY_USDV_DECIMALS } from "../tokens/usdv";

/**
 * Default salt for the main staking vault
 */
export const DEFAULT_SALT = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]);

/**
 * Token decimals for staking tokens
 */
export const TOKEN_DECIMALS = {
    /** The existing staking vault holds Legacy USDv. */
    USDv: LEGACY_USDV_DECIMALS,
    /** sUSDv has 9 decimals */
    sUSDv: 9
} as const;
